import {useState} from "react";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import DirectionAmenitiesPill from "@CheckOrder/features/amenities/features/countAmenity/features/modal/components/DirectionAmenitiesPill";

/**
 * used for toggling from/to single/return tab in amenities modal
 */
export default function useSingleAndReturnAmenitiesSelectTabs() {
    const [
        selectedTab,
        setSelectedTab,
    ] = useState<"single" | "return">("single")

    const {
        singleRoute,
        returnRoute,
    } = useAppSelector((state) => (state.checkOrder.purchasedRoute))

    const setToSingle = () => {
        setSelectedTab("single")
    }

    const setToReturn = () => {
        setSelectedTab("return")
    }

    const tabs = [
        {
            id: "single",
            label: (
                <DirectionAmenitiesPill
                    title="Outbound"
                    departureStationName={singleRoute.travelInfo.departureStation.cityName}
                    destinationStationName={singleRoute.travelInfo.destinationStation.cityName}
                />
            ),
            onClick: setToSingle,
            isActive: selectedTab === "single",
        },
        {
            id: "return",
            label: (
                <DirectionAmenitiesPill
                    title="Return"
                    departureStationName={returnRoute?.travelInfo?.departureStation?.cityName}
                    destinationStationName={returnRoute?.travelInfo?.destinationStation?.cityName}
                />
            ),
            onClick: setToReturn,
            isActive: selectedTab === "return",
        },
    ]

    return {
        selectedTab,
        tabs,
    }
}